"use client";
import { SortSelectProps } from "@/types/search.types";
import Select from "@/ui/Common/Select";
import { HandleChangeValue } from "@/ui/Common/SelectList";
import { cn } from "@/utils/cn";

export const SortSelect = ({
  value,
  options,
  onChange,
  className,
}: SortSelectProps) => {
  // Transform options to match Select component format
  const transformedOptions = options.map((option) => ({
    label: option.label,
    value: option.value,
    isActive: option.value === value,
  }));

  const handleChange = (selectedValue: HandleChangeValue) => {
    onChange(selectedValue.value);
  };

  return (
    <>
      <Select
        current={
          options.find((opt) => opt.value === value)?.label || options[0].label
        }
        list={transformedOptions}
        className={cn("h-full whitespace-nowrap z-40", className)}
        handleChange={handleChange}
        arrowColor="red"
      />
    </>
  );
};
